<template>
    <div class="transaction-details-wrapper" >
        <!--translate needed-->
        <mt-header class="dl_header_new_bg" fixed>
            <mt-button slot="left" @click.native="closeModal">
                <img class="go-back" src="@/assets/img/ico_back.png" />
            </mt-button>
        </mt-header>
        <div class="transaction-details-card" v-if="details">
            <div class="card-header">
                <div class="succes-icon"
                    :class="details.isError == 0 ? 'transaction-value-plus' : 'transaction-value-minus'">
                    <img v-if="details.isError == 0" class="succes-img" src="@/assets/img/success.svg" />

                    <div v-if="details.isError == 0">
                       {{$t('coin.tx_status3')}}
                    </div>
                    <div v-else>
                                               {{$t('coin.tx_status1')}}

                    </div>
                </div>
                <div class="transaction-value"
                    :class="details.to != walletAddress ? 'transaction-value-minus' : 'transaction-value-plus'">
                    {{ details.to != walletAddress ? '-' : '+' }}{{ details.value }}
                </div>
            </div>

            <div class="card-body">
                <div class="transaction-from" @click="copy($event, details.from)">
                    <div class="card-body-title">
                                                {{$t('coin.tx_from')}}

                    </div>
                    <div class="flex">
                        {{ details.from.length > 32 ? fixTheAddr(details.from, 12) : details.from }}
                        <img class="copy-svg" src="@/assets/img/copy.svg" />
                    </div>


                </div>

                <div class="transaction to" @click="copy($event, details.to)">
                    <div class="card-body-title">
                        {{$t('coin.tx_to')}}
                    </div>
                    <div class="flex">

                        <div> {{ details.to.length > 32 ? fixTheAddr(details.to, 12) : details.to }}</div>
                        <img class="copy-svg" src="@/assets/img/copy.svg" />
                    </div>

                </div>

                <div class="transaction-gas">
                    <div class="card-body-title">
                                                {{$t('coin.gas_fee')}}

                    </div>
                    {{ details.gasUsed }}
                </div>


            </div>

            <div class="card-footer">
                <div class="footer-left">
                    <div class="transaction-hash" @click="copy($event, details.txhash)">
                        <div class="card-body-title">
                            Transaction Hash
                        </div>
                        <div class="flex">
                            {{ details.txhash.length > 15 ? fixTheAddr(details.txhash, 6) : details.txhash }}
                            <img class="copy-svg" src="@/assets/img/copy.svg" />
                        </div>


                    </div>

                    <div class="block-number">
                        <div class="card-body-title">
                            Block Number
                        </div>

                        {{ details.blockNumber }}
                    </div>

                    <div class="time">
                        <div class="card-body-title">
                                                                            {{$t('coin.tx_time')}}

                        </div>

                        {{ secondToDate(details.timestamp) }}
                    </div>

                </div>
                <div class="footer-right">

                    <div class="qr-wrapper">
                        <div ref="qrCodeUrl" id="qrcode"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { fixTheAddress, secoendToDate } from "@/filters/index";
import handleClipboard from "@/utils/clipboard";
import { Toast } from "mint-ui";
import QRCode from "qrcodejs2";

export default {
    data() {
        return {
            qrString:''
        }
    },
    components: { Toast },

    props: ['details', 'walletAddress'],

    methods: {

        init() {
            this.qrString = ""
            this.qrString = this.details.txhash
            document.getElementById('qrcode').innerHTML = ''
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: this.qrString,
            });
        },
        fixTheAddr(add, l) {
            return fixTheAddress(add, l)
        },

        secondToDate(d) {
            return secoendToDate(d)
        },


        closeModal() {
            this.$emit(`closeDetails`)
        },

        copy: function (event, val) {
            handleClipboard(
                val,
                event,
                () => {
                    Toast(this.$t("fuzhicg"));
                },
                () => {
                    Toast(this.$t("fuzhicc"));
                }
            );
        }
    },

    mounted() {
        this.init()
    }
}
</script>

<style scoped>
.go-back {
    width: 20px;
    height: 20px;
}

.transaction-page /deep/ .mint-button--normal {
    padding: 0 !important;
}

.transaction-details-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    background-color: #f6f8fa;

    color: rgb(79, 79, 79);
    z-index: 2500;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.transaction-details-card {
    display: flex;
    position: relative;
    flex-direction: column;
    width: 80vw;
    height: 460px !important;
    background-color: white;
    padding: 8px 12px;
    border-radius: 8px;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.137);

}

.succes-img {
    height: 50px;
    width: 50px;
}

.transaction-value-plus {
    color: #57ea7e;
}

.transaction-value-minus {
    color: #FF7371;
}

.card-header {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    font-weight: bold;
}

.succes-icon {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: -25px;
    font-weight: normal;
    font-size: 0.875rem;
    z-index: 20;
    align-items: center;
    text-transform: capitalize;
}

.transaction-value {
    font-size: 1.25rem;
    letter-spacing: 0.9px;
    margin-top: 50px;
}

.card-body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 8px;
}

.card-body * {
    margin-top: 8px;

    font-size: 0.8125rem;
}

.card-body-title {
    font-size: 0.75rem;
    color: rgb(161, 161, 161);
    margin-bottom: 4px;
}

.card-footer {
    display: flex;
    width: 100%;
    margin-top: auto;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    min-height: 40%;
    padding-top: 10px;
    font-size: 0.875rem;

}

.footer-left {
    display: flex;
    flex-direction: column;
    width: 50%;
}

.footer-left * {
    margin-top: 8px;
}

.footer-right {
    display: flex;
    flex-direction: column;
    width: 50%;
}

.qr-wrapper{
    display: flex;
  width: 100%;
  justify-content: center;
}

.qr-wrapper div {
        display: flex;
    width: 100px;
    height: 100px;
}

.copy-svg {
    filter: invert(100%) sepia(0%) saturate(1168%) hue-rotate(267deg) brightness(122%) contrast(50%);
    max-width: 15px;
    width: 15px;
    height: fit-content;
    margin: 0;
    margin-left: 2px;
    display: inherit !important;

}

.flex {
    display: flex !important;
    width: 100%;

    align-items: center;
}
</style>